<script setup lang="ts">
import { Success } from '@/api/results'
import { AsyncDataKey } from '@/types/main'

import MainCategoryListDesktop from '@/components/Main/MainCategoryListDesktop.vue'
import MainCategoryListMobile from '@/components/Main/MainCategoryListMobile.vue'

type Props = {
  isCategoryPage?: boolean
  isLandingPage?: boolean
}

defineProps<Props>()

const { data: simpleCategories } = await useAsyncData(
  AsyncDataKey.SIMLE_CATEGORIES,
  async (nuxtApp) => {
    const result = await nuxtApp?.$apiService.category.fetchSimpleCategories()

    if (result instanceof Success) {
      return result.data
    }

    return []
  },
  {
    lazy: true,
  },
)

const { isDesktop } = useDevice()
</script>

<template>
  <div class="category">
    <div
      v-if="simpleCategories"
      class="category__list"
      :class="{ 'category__list--page': isCategoryPage }"
    >
      <main-category-list-desktop
        v-if="isDesktop"
        id="desktop-category"
        :simple-categories="simpleCategories"
      />

      <main-category-list-mobile
        v-else
        :simple-categories="simpleCategories"
        :is-landing-page="isLandingPage"
        :is-category-page="isCategoryPage"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.category__list {
  min-height: 112px;
  padding: 30px 0 0;

  @include media('<=desktop-mini') {
    padding: 27px 24px;
  }
  @include media('<=tablet') {
    padding: 20px 0 27px;
  }
  &--page {
    min-height: inherit;
    padding: 15px 0;
    border-bottom: 1px solid #f1f4f9;
  }
}
</style>
